import { render } from "./SavedView.vue?vue&type=template&id=22ee28ca&scoped=true"
import script from "./SavedView.vue?vue&type=script&lang=js"
export * from "./SavedView.vue?vue&type=script&lang=js"

import "./SavedView.vue?vue&type=style&index=0&id=22ee28ca&scoped=true&lang=scss"
import "./SavedView.vue?vue&type=style&index=1&id=22ee28ca&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ee28ca"]])

export default __exports__